export const EVENTS = {
    BigQuery: 'review_is_shown',
    Mixpanel: 'Viewed Reviews Item',
};
